if ($('.flag-priplatky').length) {
    function fetchData(codes, callback) {
        var url = 'https://priplatky.dostmedia.cz/api/products/ventilaVzduchotechnika?codes=' + codes.join(',');
        $.ajax({
            url: url,
            type: 'GET',
            cache: false,
            dataType: 'json',
            success: function (data) {
                callback(data);
            },
            error: function (xhr, status, error) {
                console.error("Nastala chyba při stahování dat: ", error);
            }
        });
    }

    function processData(data) {
        var addedTitles = new Set(); // Sada pro sledování již přidaných titulů

        $('.p-detail-tabs-wrapper .detail-parameters tr').each(function () {
            var $tr = $(this);
            var text = $tr.find('th>span').text();

            if (text.indexOf('#POMOCNE') !== -1) {
                
                var title = text.replace('#POMOCNE_', '').trim();
                var normalizedTitleId = title.split('_URL')[0].normalize('NFD').replace(/[^\w]/g, '').toLowerCase();

                // Pokud byl select s tímto title-id již přidán, přeskočíme
                if (addedTitles.has(normalizedTitleId)) {
                    return;
                }

                addedTitles.add(normalizedTitleId);

                var $td = $tr.find('td');
                var select = $('<select title-id="' + normalizedTitleId + '"></select>').append($('<option>', { text: 'Vyberte', value: '' }));

                if (title.includes('*')) {
                    select.attr('required', true); // Přidání atributu required, pokud title obsahuje *
                    title = title.replace('*', '').trim(); // Odstranění * ze jména pro zobrazení
                }
                if (title.includes('_URL')) {
                    title = title.split('_URL-')[0].trim(); // Odstranění * ze jména pro zobrazení
                    var urlProduct = text.replace('#POMOCNE_', '').trim().split('_URL-')[1].trim().replace(':', '');
                }

                $td.text().split(',').forEach(function (code) {
                    code = code.trim();
                    var productData = data.find(item => item.code === code);
                    if (productData) {
                        if(productData.variant === ''){
                            var productName = productData.product
                        }
                        else{
                            var productName = productData.variant.replace(title.replace(':', ''), '')
                        }
                        select.append($('<option></option>').attr('value', code).text(productName));
                    }
                });

                var selectHtml = $('<div></div>').append(select).html(); // Převod jQuery select objektu na HTML řetězec
                var customSelectDiv = '<tr class="custom-select">';
                if (text.replace('#POMOCNE_', '').trim().includes('_URL')) {
                    customSelectDiv += '<th>' + title + ' - <a href="' + urlProduct + '/" target="_blank">Info o produktu</a></th>';
                } else {
                    customSelectDiv += '<th>' + title + '</th>';
                }
                customSelectDiv += '<td>' + selectHtml + '</td></tr>'; // Přidání select boxu do správného sloupce (td)

                var $pInfoWrapper = $('.p-info-wrapper .detail-parameters tbody');
                $pInfoWrapper.append(customSelectDiv);
                $tr.hide();
                
            }

        });
    }

    $('html').on('click', '.add-to-cart-button', function () {
        $('.custom-select select').each(function () {
            var selectedValue = $(this).find('option:selected').attr('value');
            console.log(selectedValue)
            if (selectedValue) {
                shoptet.cartShared.addToCart({ productCode: '' + selectedValue + '' }, true);
            }
        })
    });

    function gatherTitleIdsToHide() {
        let toHide = new Set();
        Object.keys(dependencies).forEach(parameterId => {
            Object.values(dependencies[parameterId]).forEach(condition => {
                Object.values(condition).forEach(option => {
                    Object.values(option).forEach(ids => {
                        ids.forEach(id => toHide.add(id));
                    });
                });
            });
        });
        return toHide;
    }

    function hideSpecifiedSelects() {
        let toHide = gatherTitleIdsToHide();
        $('select[title-id]').each(function () {
            let titleId = $(this).attr('title-id');
            if (toHide.has(titleId)) {
                $(this).closest('.custom-select').hide();
            }
        });
    }

    function updateDependencies() {
        $('select[data-parameter-id]').each(function () {
            var parameterId = $(this).data('parameter-id');
            var selectedValue = $(this).val();

            if (dependencies[parameterId] && !dependencies[parameterId][selectedValue]) {
                let allDependentIds = gatherTitleIdsToHide();
                allDependentIds.forEach(id => {
                    $('select[title-id="' + id + '"]').closest('.custom-select').hide();
                    $('select[title-id="' + id + '"]').val($('select[title-id="' + id + '"]').find('option:first').val());
                    $('select[title-id="' + id + '"]').removeAttr('required');
                });
            } else if (dependencies[parameterId] && dependencies[parameterId][selectedValue]) {
                Object.keys(dependencies[parameterId][selectedValue]).forEach(depId => {
                    var text = $('select[data-parameter-id="' + depId + '"]').find('option:selected').text();
                    var condition = text.includes('x') ? 'x' : 'default';
                    let toShow = dependencies[parameterId][selectedValue][depId][condition];
                    $('select[title-id]').closest('.custom-select').hide();
                    $('select[title-id]').removeAttr('required');
                    toShow.forEach(titleId => {
                        $('select[title-id="' + titleId + '"]').closest('.custom-select').show();
                        $('select[title-id="' + titleId + '"]').attr('required', 'required');
                    });
                });
            }
        });
    }

    $(window).on('load', function () {
        var codes = [];
        $('.tab-content .detail-parameters tr').each(function () {
            var $th = $(this).find('th');
            var $td = $(this).find('td');
        
            // Zkontrolovat, zda text v th obsahuje '#POMOCNE'
            if ($th.text().indexOf('#POMOCNE') !== -1) {
                $th.closest('tr').hide()
                // Zpracovat text z td
                codes = codes.concat($td.text().split(',').map(code => code.trim()));
            }
        });

        fetchData(codes, function (data) {
            processData(data);
            hideSpecifiedSelects();  // Skryjeme specifikované selecty při načtení stránky
            $('select[data-parameter-id]').change(updateDependencies); // Posluchač změn
            updateDependencies(); // Aktualizujeme závislosti při načtení stránky
        });
    });
}
